import { lazy } from 'react';

const Login = lazy(() => import('./pages/ModulosBase/Login/Login'));
const Mapa = lazy(() => import('./pages/ModulosBase/Mapa/MapaPruebaPLC'));
const Dashboard = lazy(() => import('./pages/ModulosBase/Dashboard/overview/Overview'));
const Graficas = lazy(() => import('./pages/ModulosBase/Dashboard/graficas/Graficas'));
const Lecturas = lazy(() => import('./pages/ModulosBase/Dashboard/lecturas/Lecturas'));
const Informacion = lazy(() => import('./pages/ModulosBase/Dashboard/informacion/Informacion'));

// H3.5 — Páginas NO ruteadas: Admin (AdminSitios/AdminUsuarios/GenKeys),
// UploadCSV, Reportes (ReporteZonas/ReporteZonasAuto/ReporteCalidad) y
// Comparador. Aún usan el patrón v1 con tenant fijo (VITE_PROYECTO, ya
// eliminado) → quedan fuera del build hasta migrarlas a v2 multitenant.
// Los archivos se conservan en src/pages para reconectarlas cuando se migren.

export const publicRoutes = [
  { path: '/', Component: Login },
];

export const protectedRoutes = [
  { path: '/mapa', Component: Mapa, withLayout: false },
  { path: '/dashboard/overview', Component: Dashboard, withLayout: true },
  { path: '/dashboard/graficas', Component: Graficas, withLayout: true },
  { path: '/dashboard/lecturas', Component: Lecturas, withLayout: true },
  { path: '/dashboard/informacion', Component: Informacion, withLayout: true },
 
];
